module.exports = __webpack_public_path__ + "img/remove-rewardcard.283497ba.svg";